// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/payment/v2/promo.proto (package gdx.gateway.web.payment.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * List available promo types.
 *
 * @generated from enum gdx.gateway.web.payment.v2.PromoType
 */
export enum PromoType {
  /**
   * @generated from enum value: PROMO_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PROMO_TYPE_TRIAL = 1;
   */
  TRIAL = 1,

  /**
   * @generated from enum value: PROMO_TYPE_DISCOUNT = 2;
   */
  DISCOUNT = 2,

  /**
   * @generated from enum value: PROMO_TYPE_OFFBOARDING_DELETE = 3;
   */
  OFFBOARDING_DELETE = 3,

  /**
   * @generated from enum value: PROMO_TYPE_OFFBOARDING_UNSUBSCRIBE = 4;
   */
  OFFBOARDING_UNSUBSCRIBE = 4,

  /**
   * @generated from enum value: PROMO_TYPE_TRIAL_BLOCK = 5;
   */
  TRIAL_BLOCK = 5,

  /**
   * @generated from enum value: PROMO_TYPE_LIMITED = 6;
   */
  LIMITED = 6,

  /**
   * @generated from enum value: PROMO_TYPE_EASY_STARTER = 7;
   */
  EASY_STARTER = 7,

  /**
   * @generated from enum value: PROMO_TYPE_EARLY_PREM_BONUS = 8;
   */
  EARLY_PREM_BONUS = 8,

  /**
   * @generated from enum value: PROMO_TYPE_BOOK = 9;
   */
  BOOK = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(PromoType)
proto3.util.setEnumType(PromoType, "gdx.gateway.web.payment.v2.PromoType", [
  { no: 0, name: "PROMO_TYPE_INVALID" },
  { no: 1, name: "PROMO_TYPE_TRIAL" },
  { no: 2, name: "PROMO_TYPE_DISCOUNT" },
  { no: 3, name: "PROMO_TYPE_OFFBOARDING_DELETE" },
  { no: 4, name: "PROMO_TYPE_OFFBOARDING_UNSUBSCRIBE" },
  { no: 5, name: "PROMO_TYPE_TRIAL_BLOCK" },
  { no: 6, name: "PROMO_TYPE_LIMITED" },
  { no: 7, name: "PROMO_TYPE_EASY_STARTER" },
  { no: 8, name: "PROMO_TYPE_EARLY_PREM_BONUS" },
  { no: 9, name: "PROMO_TYPE_BOOK" },
]);

